import { render, staticRenderFns } from "./OtherProduct.vue?vue&type=template&id=2ef4390e&scoped=true&"
import script from "./OtherProduct.vue?vue&type=script&lang=ts&"
export * from "./OtherProduct.vue?vue&type=script&lang=ts&"
import style0 from "./OtherProduct.vue?vue&type=style&index=0&id=2ef4390e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4390e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
